import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ApuResourceApiModel } from '@/core/models/api/apu-resource-api.model';

export const selectApuResourceId = (a: ApuResourceApiModel): number => {
    if (!a.apuResourceId) {
        throw new Error("apuResourceId is required");
    }
    return a.apuResourceId;
}
// Entity setup
export interface ApuResourceState extends EntityState<ApuResourceApiModel> {
    errorMessage: string | null;
}

// Pure function adapter
export const apuResourceAdapter: EntityAdapter<ApuResourceApiModel> = createEntityAdapter<ApuResourceApiModel>(
    {
        selectId: selectApuResourceId,
        sortComparer: false
    }
);

// Initial state
export const initialApuResourceState: ApuResourceState =
    apuResourceAdapter.getInitialState({
        errorMessage: null
    });